/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_PowerInputs */

const en_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 credits for EUR 19.99 (one-time payment)`)
};

const de_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 Credits fuer EUR 19,99 (einmalige Zahlung)`)
};

const fr_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power : 150 credits pour EUR 19,99 (paiement unique)`)
};

const es_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 creditos por EUR 19,99 (pago unico)`)
};

const it_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 crediti a EUR 19,99 (pagamento unico)`)
};

const nl_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 credits voor EUR 19,99 (eenmalige betaling)`)
};

const pl_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 kredytow za EUR 19,99 (platnosc jednorazowa)`)
};

const fi_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 krediittiä hintaan EUR 19,99 (kertamaksu)`)
};

const da_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 credits for EUR 19,99 (engangsbetaling)`)
};

const sv_agb_credit_packs_power = /** @type {(inputs: Agb_Credit_Packs_PowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power: 150 krediter for EUR 19,99 (engangsbetalning)`)
};

/**
* | output |
* | --- |
* | "Power: 150 credits for EUR 19.99 (one-time payment)" |
*
* @param {Agb_Credit_Packs_PowerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_power = /** @type {((inputs?: Agb_Credit_Packs_PowerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_PowerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_power(inputs)
	if (locale === "fr") return fr_agb_credit_packs_power(inputs)
	if (locale === "es") return es_agb_credit_packs_power(inputs)
	if (locale === "it") return it_agb_credit_packs_power(inputs)
	if (locale === "nl") return nl_agb_credit_packs_power(inputs)
	if (locale === "pl") return pl_agb_credit_packs_power(inputs)
	if (locale === "fi") return fi_agb_credit_packs_power(inputs)
	if (locale === "da") return da_agb_credit_packs_power(inputs)
	if (locale === "sv") return sv_agb_credit_packs_power(inputs)
	return en_agb_credit_packs_power(inputs)
});